var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDropdownIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 12.833H10.5V11.6663C10.5 10.6998 9.71651 9.91634 8.74998 9.91634H5.24998C4.28348 9.91634 3.49998 10.6998 3.49998 11.6663V12.833H2.33331V11.6663C2.33331 10.0555 3.63915 8.74967 5.24998 8.74967H8.74998C10.3608 8.74967 11.6666 10.0555 11.6666 11.6663V12.833ZM6.99998 7.58301C5.06698 7.58301 3.49998 6.016 3.49998 4.08301C3.49998 2.15001 5.06698 0.583008 6.99998 0.583008C8.93297 0.583008 10.5 2.15001 10.5 4.08301C10.5 6.016 8.93297 7.58301 6.99998 7.58301ZM6.99998 6.41634C8.28862 6.41634 9.33331 5.37167 9.33331 4.08301C9.33331 2.79434 8.28862 1.74967 6.99998 1.74967C5.71131 1.74967 4.66665 2.79434 4.66665 4.08301C4.66665 5.37167 5.71131 6.41634 6.99998 6.41634Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdownIcon01);
export default __webpack_public_path__ + "static/media/user-dropdown-icon--01.396e498654af6dfd153e8dd3341f4e73.svg";
export { ForwardRef as ReactComponent };